import { Form } from "./form-builder";
import TintEcommerceMeasure from "./analytics/tint-ecommerce-measure";
import { tintFormTagName } from "../public/js/react/feature/form-builder/utils/form-builder.types";
import { OldFormsEmbedCodeService } from "./form-builder/services/old-forms-embed-code.service";
const init = () => {
  OldFormsEmbedCodeService.fixFormsWithDivTag();
  window.Tint = {
    TintEcommerceMeasure,
    WebComponents: {
      Form
    },
    formScriptFetched: false
  };
  const tintForm = customElements.get(tintFormTagName);
  if (!tintForm) {
    customElements.define(tintFormTagName, window.Tint.WebComponents.Form);
  }
};
if (typeof window !== "undefined") {
  if (window._env_) {
    init();
  } else {
    const script = document.createElement("script");
    script.src = `${new URL(document.currentScript.src).origin}/dist/env-config.js`;
    script.async = true;
    script.onload = init;
    document.head.appendChild(script);
  }
}
